import React from 'react';
import { workOf, WorkJob, WorkAddon } from '../../utils/crewWork';

/**
 * What to do at a stop, on the crew's screens: the work ("Mowing", or the
 * job's own name), then anything else on the visit on its own line as
 * "Additional: …" — beside the mowing, never instead of it (owner, Sep 30
 * 2026: "say mowing and if it's anything additional add as additional not
 * instead"). The words come from utils/crewWork.
 *
 *   tone   'light' on white cards, 'dark' on the route runner's card
 *   size   'sm' list rows · 'md' cards · 'lg' the job page header
 *   showMain=false when the heading above already says the work (a to-do)
 */
export default function WorkLine({ job, addons, tone = 'light', size = 'sm', showMain = true, className = '' }: {
  job: WorkJob | null | undefined;
  addons?: WorkAddon[] | null;
  tone?: 'light' | 'dark';
  size?: 'sm' | 'md' | 'lg';
  showMain?: boolean;
  className?: string;
}) {
  if (!job) return null;
  const w = workOf(job, addons);
  if (!showMain && !w.additional.length) return null;
  const mainSize = size === 'lg' ? 'text-base' : size === 'md' ? 'text-sm' : 'text-xs';
  const addSize = size === 'sm' ? 'text-xs' : 'text-sm';
  const mainCls = tone === 'dark' ? 'text-white' : 'text-gray-800';
  const addCls = tone === 'dark' ? 'text-white' : 'text-emerald-800';
  const labelCls = tone === 'dark' ? 'text-brand-200' : 'text-emerald-700';
  return (
    <div className={className}>
      {showMain && <p className={`${mainSize} font-bold leading-snug ${mainCls}`}>{w.main}</p>}
      {w.additional.length > 0 && (
        <p className={`${addSize} leading-snug ${addCls}`}>
          <span className={`font-bold uppercase tracking-wide text-[11px] ${labelCls}`}>Additional:</span>{' '}
          <span className="font-semibold">{w.additional.join(', ')}</span>
        </p>
      )}
    </div>
  );
}
